import { normalizeEuro } from '@amo/core/utils/normalize';
import _ from 'lodash';
import { useState } from 'react';
import LastOptions from './LastOptions';
import locker from "@amo/core/assets/images/icons/locker.png";
import paiement from "@amo/core/assets/images/icons/paiement.png";
import {getTranslation} from "@amo/core/utils/index.js";

const Souscrire = (props) => {
    const {
        codePromo,
        loading,
        formuleChoisie,
        postFill,
        changeValue,
        data,
        prixTotalMensuel,
        prixTotalMensuelPromo,
        prixTotalAnnuel,
        prixTotalAnnuelPromo,
        nbOptions,
        options,
        apporteur1,
        analyticsSetEvent,
        urlDocumentInformation,
    } = props;
    const [showLastOptions, setShowLastOptions] = useState(false);
    const [typeSubscribe, setTypeSubscribe] = useState(null);
    const optionsChoisi = _.get(data, 'options');

    const handleFractionnement = (value) => {
        analyticsSetEvent({event: 'mensuelAnnuel', datas: {
            'mensuelAnnuel' : {
                'bouton' : value === 'A' ? 'Annuel' : 'Mensuel'
            }
        }})
        changeValue('DemandeTarif[Police][FractionnementChoisi]', value);
    };

    const validateStepTarif = (type) => {
        if (
            (!optionsChoisi?.PCC && _.find(options, ['idGroupe', 'PCC'])) ||
            (!optionsChoisi?.ASS && _.find(options, ['idGroupe', 'ASS']))
        ) {
            setTypeSubscribe(type);
            setShowLastOptions(true);
        } else {
            setShowLastOptions(false);
            changeValue('typeDevis', type);
            postFill({ getTarif: false });
        }
    };

    return (
        <div id={'souscrire'} className={'container '}>
            <div className={`row mt-4`}>
                <div className={'col-12'}>
                    <div className={'bg-white border rounded p-lg-4 py-3 px-0 row align-items-center'}>
                        {/* Desktop */}
                        <div className="col-12 col-xxl-2 col-xl-6 col-lg-6 text-start mb-3 mb-xxl-0 d-none d-lg-block">
                            <p className={'f-14 fw-bold'}>{getTranslation('summary.yourContract')}</p>
                            <span className="f-24 fw-bold">
                                {formuleChoisie && formuleChoisie.LibelleFormule?.toUpperCase()}
                            </span>
                            {nbOptions >= 1 && (
                                <p className={'f-14 text-secondary'}>
                                    + {nbOptions} option{nbOptions > 1 ? 's' : ''}
                                </p>
                            )}
                        </div>
                        {/* Mobile */}
                        <div className="col-12 col-lg-4 text-start mb-3 mb-lg-0 d-block d-lg-none">
                            <p className={'f-14 fw-bold'}>
                                {getTranslation('summary.yourContract')}{' '}
                                <span className="f-24 fw-bold">
                                    {formuleChoisie && formuleChoisie.LibelleFormule?.toUpperCase()}
                                </span>{' '}
                                {nbOptions >= 1 && (
                                    <span className={'f-14 text-secondary'}>
                                        + {nbOptions} option{nbOptions > 1 ? 's' : ''}
                                    </span>
                                )}
                            </p>
                        </div>
                        <div className="d-none d-lg-block col-12 col-xxl-2 col-xl-6 col-lg-6 text-start mb-3 mb-xxl-0 text-xxl-start text-xl-end">
                            {_.get(data, 'DemandeTarif[Police][FractionnementChoisi]') === 'M' && (
                                <div className={'mois'}>
                                    {codePromo?.Eligible && prixTotalMensuelPromo < prixTotalMensuel ? (
                                        <>
                                            <span className={'f-30 fw-bold text-secondary'}>
                                                {normalizeEuro(prixTotalMensuelPromo)}
                                            </span>
                                            <small className={'f-10'}>/mois*</small>
                                            <small className={'d-block f-14 text-decoration-line-through'}>
                                                {normalizeEuro(prixTotalMensuel)}/mois*
                                            </small>
                                        </>
                                    ) : (
                                        <>
                                            <span className={'f-30 fw-bold text-secondary'}>
                                                {normalizeEuro(prixTotalMensuelPromo)}
                                            </span>
                                            <small className={'f-10'}>/{getTranslation('months')}*</small>
                                        </>
                                    )}
                                </div>
                            )}

                            {_.get(data, 'DemandeTarif[Police][FractionnementChoisi]') === 'A' && (
                                <div className={'an'}>
                                    {codePromo?.Eligible && prixTotalAnnuelPromo < prixTotalAnnuel ? (
                                        <>
                                            <span className={'f-30 fw-bold text-secondary'}>
                                                {normalizeEuro(prixTotalAnnuelPromo)}
                                            </span>
                                            <small className={'f-10'}>/an*</small>
                                            <small className={'d-block f-14 text-decoration-line-through'}>
                                                {normalizeEuro(prixTotalAnnuel)}/an*
                                            </small>
                                        </>
                                    ) : (
                                        <>
                                            <span className={'f-30 fw-bold text-secondary'}>
                                                {normalizeEuro(prixTotalAnnuel)}
                                            </span>
                                            <small className={'f-10'}>/{getTranslation('year')}*</small>
                                        </>
                                    )}
                                </div>
                            )}
                            <small className={'f-12'}>*{getTranslation('price')} TTC</small>
                        </div>
                        <div className="col-12 col-xxl-4 col-xl-6 col-lg-12 text-start mb-3 mb-xxl-0">
                            <p className={'f-13 fw-bold mb-1'} dangerouslySetInnerHTML={{ __html: getTranslation('pricing.subscribe.iWantPayTo') }}/>
                            <div className={`fractionnement-select d-flex`}>
                                <button
                                    className={`btn-frac ${
                                        _.get(data, 'DemandeTarif[Police][FractionnementChoisi]') === 'M' && 'select'
                                    } p-2 f-12 w-100 h-100`}
                                    onClick={() => handleFractionnement('M')}
                                >
                                    <p className={'f-14 fw-bold text-dark'}>Mensuel</p>
                                    {codePromo?.Eligible && prixTotalMensuelPromo < prixTotalMensuel ? (
                                        <>
                                            <small className={'f-14 fw-bold d-block'}>
                                                {normalizeEuro(prixTotalMensuelPromo)} / {getTranslation('months')} TTC
                                            </small>
                                            <small className={'f-12 text-decoration-line-through'}>
                                                {normalizeEuro(prixTotalMensuel)} / {getTranslation('months')} TTC
                                            </small>
                                        </>
                                    ) : (
                                        <small className={'f-14 fw-bold'}>
                                            {normalizeEuro(prixTotalMensuelPromo)} <br/> par {getTranslation('months')} TTC
                                        </small>
                                    )}
                                </button>
                                <button
                                    className={`btn-frac ${
                                        _.get(data, 'DemandeTarif[Police][FractionnementChoisi]') === 'A' && 'select'
                                    } p-2 f-12 w-100 h-100`}
                                    onClick={() => handleFractionnement('A')}
                                >
                                    <p className={'f-14 fw-bold text-dark'} dangerouslySetInnerHTML={{__html: getTranslation('pricing.subscribe.promoAnnual', {amount: "-10"})}} />
                                    {codePromo?.Eligible && prixTotalAnnuelPromo < prixTotalAnnuel ? (
                                        <>
                                            <small className={'f-14 fw-bold d-block'}>
                                                {normalizeEuro(prixTotalAnnuelPromo)} / {getTranslation('year')} TTC
                                            </small>
                                            <small className={'f-12 text-decoration-line-through'}>
                                                {normalizeEuro(prixTotalAnnuel)} / {getTranslation('year')} TTC
                                            </small>
                                        </>
                                    ) : (
                                        <small className={'f-14 fw-bold'}>{normalizeEuro(prixTotalAnnuel)}
                                            <br/> par {getTranslation('year')} TTC</small>
                                    )}
                                </button>
                            </div>
                        </div>
                        <div className={'col-12 col-xxl-3 col-xl-6 col-lg-6 col-md-6 offset-md-3 offset-lg-0 text-center d-flex flex-column'}>
                            {loading ? (
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                            ) : (
                                <>
                                    <button
                                        className={`btn btn-primary btn-smaller btn-arrow mb-2`}
                                        onClick={() => validateStepTarif('subscribe')}
                                        data-cy={'subscribe-button'}
                                    >
                                        {getTranslation('subscribe')}
                                    </button>
                                    <p className={'text-grey f-12 fw-bold mb-1'}>
                                        <img src={locker} alt="" aria-hidden="true" loading="lazy"/>
                                        {getTranslation('footer.securePayment')} <img src={paiement} alt="Cartes bancaires acceptées : Mastercard et Visa" width={88} height={27} loading="lazy"/>
                                    </p>
                                    <button
                                        className={`btn btn-secondary btn-smaller btn-arrow d-block`}
                                        onClick={() => validateStepTarif('devis')}
                                        style={{padding: '14px 10px'}}
                                    >
                                        {getTranslation('pricing.subscribe.receiveProposalByEmail')}
                                    </button>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {urlDocumentInformation && (
                <div className={'row mt-3'}>
                    <div className={'col-12 text-center'}>
                        <p className={'f-14 mb-0'}>
                            <a href={urlDocumentInformation} target="_blank" rel="noopener noreferrer">
                                Veuillez trouver ci-joint le document d’information sur le produit d’assurance proposé.
                            </a>
                        </p>
                    </div>
                </div>
            )}

            {showLastOptions && (
                <LastOptions {...props} setShowLastOptions={setShowLastOptions} typeSubscribe={typeSubscribe}/>
            )}
        </div>
    );
};

export default Souscrire;
